<!--*
 * List of items needed by the surveyor
 *
 * @author   mauricio.figueroa
 * @date     2020-06-30
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div>
    <SubMenuHeader :title="$t('itemsNeeded.pageTitle')" @onGoBack="goBack" @showVideo="$emit('showVideo')" />
    <div class="container--fluid">
      <AppItemList class="mt-7" />
    </div>
  </div>
</template>

<script>
import SubMenuHeader from './SubMenuHeader';
import AppItemList from "@/components/SharedComponents/AppItemList.vue";
import store from '../store/store';

export default {
  'name': 'ItemsNeeded',
  'components': { AppItemList, SubMenuHeader },
  'computed': {
    isHeaderHidden() {
      return store.getters.HideHeaderBar();
    },
  },
  'methods': {
    'goBack': function () {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>
.container--fluid {
  background-color: #fafafa;
  height: 100vh;
}

.submenu-header-space {
  top: 52px;
}

</style>
